import { render, staticRenderFns } from "./LegendDialog.vue?vue&type=template&id=408874ec&scoped=true&"
import script from "./LegendDialog.vue?vue&type=script&lang=ts&"
export * from "./LegendDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LegendDialog.vue?vue&type=style&index=0&id=408874ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408874ec",
  null
  
)

export default component.exports